export default "__VITE_ASSET__BsHl5qTT__"